import { amplifyClient, axios } from 'api';
import { createApiSlice } from 'helpers/createApiSlice';
import { call } from 'redux-saga/effects';

type Payload = {
  files: {
    pdf: File;
    xml: File;
    extraData: Record<string, unknown>;
  };
  endpoint: string;
};

export const uploadDocs = createApiSlice<unknown, Payload>({
  nestedPath: [],
  name: 'uploadDocs',
  *tryGenerator(_, { payload: { files, endpoint } }) {
    const { extraData, xml, pdf } = files;

    const { requestId, url: xmlURL } = yield call(amplifyClient, {
      method: 'post',
      url: endpoint,
      data: {
        doctype: 'INVOICE',
        ext: 'xml',
        extradata: extraData,
      },
    });

    yield call(axios, {
      method: 'put',
      url: xmlURL,
      data: xml,
    });

    if (pdf) {
      const { url: pdfURL } = yield call(amplifyClient, {
        method: 'post',
        url: endpoint,
        data: {
          doctype: 'INVOICE_PDF',
          ext: 'pdf',
          extradata: extraData,
          MUI: requestId,
        },
      });

      yield call(axios, {
        method: 'put',
        url: pdfURL,
        data: pdf,
      });
    }

    return null;
  },
});
